import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubsemnatulComponent } from './subsemnatul.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [SubsemnatulComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [SubsemnatulComponent],
})
export class SubsemnatulModule {}
